module.exports = __webpack_public_path__ + "img/qixiang.2b547821.png";